module.exports = __webpack_public_path__ + "img/icon_sr-weeks-configuration.31ecdc24.svg";